import type { DatumId } from "@nivo/pie";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

interface LegendComponentProps {
  className?: string;
  data: {
    id: DatumId;
    color: string;
    label: string;
  }[];
  orientation?: "horizontal" | "vertical";
  rootLocale?: string[];
  setActiveId: (id: DatumId | null) => void;
}

export const LegendComponent = ({
  data,
  orientation = "horizontal",
  className,
  setActiveId,
  rootLocale,
}: LegendComponentProps) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames(
        "flex gap-4",
        orientation === "horizontal"
          ? "flex-row flex-wrap justify-center"
          : "flex-col",
        className,
      )}
    >
      {data.map(item => (
        <div
          key={item.label}
          className="flex cursor-pointer items-center gap-2"
          onMouseOver={() => setActiveId(item.id)}
          onFocus={() => setActiveId(item.id)}
          onMouseLeave={() => setActiveId(null)}
          onBlur={() => setActiveId(null)}
        >
          <div
            className="size-3 shrink-0 rounded-full"
            style={{ backgroundColor: item.color }}
          />
          <Typography.BodySm color="text-secondary dark:text-white">
            {rootLocale ? t([...rootLocale, item.label]) : item.label}
          </Typography.BodySm>
        </div>
      ))}
    </div>
  );
};
